import { Component, OnInit } from '@angular/core';
import { NavigationConfigService } from '@ispm/dashboard/navigation/services/navigationConfig.service';
import { DynamicModalAbstractComponent } from '@ispm/layout/classes/dynamic-modal-abstract-component';
import { DynamicModalLoaderService } from '@ispm/layout/services/dynamic-modal-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { DashboardService } from '../../../worklist/services/dashboard.service';

@Component({
    selector: 'gen-about-box',
    templateUrl: './about-box.component.html',
    styleUrls: ['./about-box.component.scss']
})
export class AboutBoxComponent extends DynamicModalAbstractComponent  implements OnInit {
    public dlsDialogData: any;
    public appName: string = 'IntelliSpace Precision Medicine';
    public appLogo: string = 'icon-dls-about';
    public productionStartYear:  any = '2016';
    getClinicalUsageData: any;
    forTestingPurposesOnly: any;
    forTestingPurposesOnlyMessage: any;
    public constructor(modalLoaderService: DynamicModalLoaderService,
                       private dashboardService: DashboardService,
                       private navigationConfigService: NavigationConfigService,
                       private translateService: TranslateService) {
                        super(modalLoaderService);
    }
    onNext(payload: any): void {
        this.dlsDialogData = payload && payload['payload'] || '';
    }

    onError(error): void {
    }

    onComplete(): void {
    }

    public ngOnInit() {
      this.initDialog();
    }

    public initDialog() {
      this.dlsDialogData.aboutBoxContent.oncosignal = false;
      if ((this.dlsDialogData.aboutBoxContent.Disclaimer.split('WARNING_ICON')).length > 1) {
        this.dlsDialogData.aboutBoxContent.Disclaimer_MainscreenlabelingAppKey1 = this.translateService.instant('AboutBox-MainscreenlabelingAppKey1');
        this.dlsDialogData.aboutBoxContent.Disclaimer_MainscreenlabelingAppKey2 = this.translateService.instant('AboutBox-MainscreenlabelingAppKey2');
      } else {
        this.dlsDialogData.aboutBoxContent.Disclaimer_MainscreenlabelingAppKey1 = this.translateService.instant('AboutBox-MainscreenlabelingKey');
        this.dlsDialogData.aboutBoxContent.Disclaimer_MainscreenlabelingAppKey2 = '';
      }
      this.dlsDialogData.aboutBoxContent.Subtitle = (this.dlsDialogData.aboutBoxContent.Subtitle)?.trim();
      if (this.dlsDialogData.aboutBoxContent.Subtitle !== '') {
        this.dlsDialogData.aboutBoxContent.Subtitle_ResearchOnlySystemKey = this.translateService.instant('AboutBox-ResearchOnlySystemKey');
      } else {
        this.dlsDialogData.aboutBoxContent.Subtitle_ResearchOnlySystemKey = '';
      }
      this.dlsDialogData.aboutBoxContent.Text_Pathology_Genomics_US_aboutPhilipsTxtKey = this.translateService.instant('Pathology-Genomics-US-aboutPhilipsTxtKey');
      this.dlsDialogData.aboutBoxContent.Text_Pathology_Genomics_US_aboutTxtKey = this.translateService.instant('Pathology-Genomics-US-aboutTxtKey');
      const applicationName = this.translateService.instant(this.dlsDialogData.aboutBoxContent.Title);
      this.dashboardService.getClinicalUsageMessage().then((data) => {
        this.getClinicalUsageData = data;
        const nonClinicalUsage = data;
        this.forTestingPurposesOnly = nonClinicalUsage ? nonClinicalUsage.forTestingOnly : false;
        this.forTestingPurposesOnlyMessage = nonClinicalUsage && nonClinicalUsage.forTestingOnly ? nonClinicalUsage.message : '';
        this.dlsDialogData.dashboarddata = data;
        this.dlsDialogData.forTestingPurposesOnly = this.forTestingPurposesOnly;
        this.dlsDialogData.forTestingPurposesOnlyMessage = this.forTestingPurposesOnlyMessage;
        if (this.forTestingPurposesOnly) {
          this.appName = applicationName + ' (WIP)' ;
        } else {
          this.appName = applicationName ;
        }
      });
      this.navigationConfigService.getCurrentApp().subscribe((app) => {
        if (app.id === 'ISPM-ONCO-SIGNAL-APP') {
          this.appLogo = 'OncoSIGNal__icon__Innosign';
          this.dlsDialogData.aboutBoxContent.oncosignal = true;
        }
      });
    }

    closeThisDialog(payload: any) {
      super.close(payload);
    }
}
